// @flow
import React from "react";
import SvgIconContainer from '../SvgIconContainer';

export default (
	{
		unit = 'em',
		...rest
	}: Object = {}) => (
	<SvgIconContainer viewBox="0 0 16 16" {...rest} unit={unit}>
		<g stroke="none" strokeWidth="1" fillRule="evenodd">
			<path d="M9.04249387,5.02449479 L9.04249387,12.5571429 C9.04249387,12.8714286
				8.88152808,13 8.52740333,13 L7.02891667,13 L7.02891667,5.02449479 L4,
				5.02449479 L4,3 L12,3 L12,5.02449479 L9.04249387,5.02449479 Z M16,
				7.5 L13.5,10 L13.5,8.54166667 L11,8.54166667 L11,6.45833333 L13.5,6.45833333
				L13.5,5 L16,7.5 Z M-5.92624058e-15,9.5 L2.5,7 L2.5,8.45833333 L5,8.45833333
				L5,10.5416667 L2.5,10.5416667 L2.5,12 L-5.92624058e-15,9.5 Z" />
		</g>
	</SvgIconContainer>
);


// WEBPACK FOOTER //
// ./src/components/Icons/Trade.js